import { useworkspaceAuthMeV2Query } from '@/types/generated/graphql';
import { cacheOnly, date_format, fallbackTz } from '@shared/constants';
import dayjs, { Dayjs } from 'dayjs';

export function useGetWorkspaceTimezone() {
  const { data: authMeWorkspaceData } = useworkspaceAuthMeV2Query(cacheOnly);
  const timezone = authMeWorkspaceData?.workspaceAuthMeV2?.data?.timezone || fallbackTz;
  const timezoneId = authMeWorkspaceData?.workspaceAuthMeV2?.data?.timezoneId;

  const transformDateFormat = (date: string | Dayjs, format: string = date_format): string => {
    try {
      const formattedDate = dayjs(date)
        .tz(timezone as string)
        .format(format);
      return formattedDate;
    } catch (error) {
      console.error(error);
      return '';
    }
  };

  const convertToUTC = (date: string, time: string) => {
    const localDateTime = dayjs.tz(`${date}T${time}`, timezone);
    return localDateTime.utc().format();
  };

  return { timezone, transformDateFormat, convertToUTC, timezoneId };
}
